module.exports = __webpack_public_path__ + "img/ab_right2.9822d718.png";